// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-product .card-body[data-v-3fb6b2be]{border-left-width:0;border-right-width:0}", "",{"version":3,"sources":["webpack://./resources/js/components/Products/ProductCard.vue"],"names":[],"mappings":"AAAA,0CAAyB,mBAAmB,CAAC,oBAAoB","sourcesContent":[".card-product .card-body{border-left-width:0;border-right-width:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
